import { api, endpoints } from "../api";
import { AxiosPromise } from "axios";

const generateAccount = (trainerId: number): AxiosPromise<number> => {
  return api.post<number>(endpoints.TRAINERS.GENERATE_ACCOUNT(trainerId));
};

const sendInvite = (trainerId: number): AxiosPromise<void> => {
  return api.post(endpoints.TRAINERS.SEND_INVITE(trainerId));
};

const unlinkAccount = (trainerId: number): AxiosPromise<void> => {
  return api.post(endpoints.TRAINERS.UNLINK_ACCOUNT(trainerId));
};

export interface BulkTrainerActionResultApi {
  succeeded: number[];
  skipped: { trainerId: number; trainerName: string; reason: string }[];
}

const bulkGenerateAccount = (trainerIds: number[]): AxiosPromise<BulkTrainerActionResultApi> => {
  return api.post<BulkTrainerActionResultApi>(endpoints.TRAINERS.BULK_GENERATE_ACCOUNT(), { trainerIds });
};

const bulkSendInvite = (trainerIds: number[]): AxiosPromise<BulkTrainerActionResultApi> => {
  return api.post<BulkTrainerActionResultApi>(endpoints.TRAINERS.BULK_SEND_INVITE(), { trainerIds });
};

export const trainerAccountApi = {
  generateAccount,
  sendInvite,
  unlinkAccount,
  bulkGenerateAccount,
  bulkSendInvite,
};
